module.exports = __webpack_public_path__ + "static/media/big-laptop-small.b8657e33.jpg";